import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiResponse } from '@core/interface/api-response.interface';
import { PageableResponse } from '@core/interface/pageable.interface';
import { RefId } from '@core/interface/ref-id.interface';
import { UrlBuilder } from '@core/model/url-builder';
import { CompanyCollectorGroupResponseDto } from '@domain/company-collector-group/dtos/company-collector-group-response.dto';
import { CreateCompanyCollectorGroupRequestDto } from '@domain/company-collector-group/dtos/create-company-collector-group-request.dto';
import { ListCompanyCollectorGroupRequestDto } from '@domain/company-collector-group/dtos/list-company-collector-group.dto-request';
import { UpdateCompanyCollectorGroupMerchantsRequestDto } from '@domain/company-collector-group/dtos/update-company-collector-group-merchants-request.dto';
import { UpdateCompanyCollectorGroupRequestDto } from '@domain/company-collector-group/dtos/update-company-collector-group-request.dto';

@Injectable({
  providedIn: 'root',
})
export class CompanyCollectorGroupService extends UrlBuilder {
  constructor(private http: HttpClient) {
    super('company/collector/group');
  }

  list(request: ListCompanyCollectorGroupRequestDto) {
    const queryUrl = `${this.getApiUrl()}/list`;
    return this.http.get<
      ApiResponse<PageableResponse<CompanyCollectorGroupResponseDto>>
    >(queryUrl, {
      params: { ...request } as any,
    });
  }

  create(request: CreateCompanyCollectorGroupRequestDto) {
    const queryUrl = `${this.getApiUrl()}/`;
    return this.http.post<ApiResponse<CompanyCollectorGroupResponseDto>>(
      queryUrl,
      request,
    );
  }

  update(request: UpdateCompanyCollectorGroupRequestDto) {
    const { refId, ...body } = request;
    const queryUrl = `${this.getApiUrl()}/${refId}`;
    return this.http.put<ApiResponse<CompanyCollectorGroupResponseDto>>(
      queryUrl,
      body,
    );
  }

  updateMerchants(request: UpdateCompanyCollectorGroupMerchantsRequestDto) {
    const { refId, ...body } = request;
    const queryUrl = `${this.getApiUrl()}/${refId}/merchants`;
    return this.http.put<ApiResponse<CompanyCollectorGroupResponseDto>>(
      queryUrl,
      body,
    );
  }

  delete(request: RefId) {
    const queryUrl = `${this.getApiUrl()}/${request.refId}`;
    return this.http.delete<ApiResponse<CompanyCollectorGroupResponseDto>>(
      queryUrl,
    );
  }
}
